import API from "../../core/apiConfig";
import { withRowKeys } from "../../core/response";
import type {
  GroupAssignPayload,
  GroupPayload,
  GroupQueryParams,
} from "./types";

const getListUserGroup = async (params: GroupQueryParams) => {
  const response = await API.get("admin/groups/all", params).then(
    (res) => res.data,
  );

  if (response.success) return { data: withRowKeys(response.data) };
};

const getDetailGroup = async (params: GroupQueryParams, id: string) => {
  const response = await API.get(`admin/groups/${id}`, params).then(
    (res) => res.data,
  );

  if (response.success) return { data: response.data };
};

const postCreateGroup = async (params: GroupPayload) => {
  const response = await API.post("admin/groups", params).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const putUpdateGroup = async (params: GroupPayload, id: string) => {
  const response = await API.put(`admin/groups/${id}`, params).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const putUpdateGroupAssign = async (params: GroupAssignPayload, id: string) => {
  const response = await API.put(`admin/groups/${id}/assign`, params).then(
    (res) => res.data,
  );

  if (response.success) return true;
};

export default {
  getListUserGroup,
  getDetailGroup,
  postCreateGroup,
  putUpdateGroup,
  putUpdateGroupAssign,
};
